'use client';

import { config } from '@/apollo/config';
import { Link, useRouter } from '@/i18n/navigation';
import Image from 'next/image';
import styles from './shares.module.scss';
import { useTranslations } from 'next-intl';
import { decodeBase64Id } from '@/helpers/decodeBase64Id';

type Props = {
  image: string | any;
  title: string;
  day: string | number; // Day of the week (Monday, Tuesday, Wednesday, etc.)
  id: string;
  slug: string;
  //... other props as needed
  // onClick: (event: React.MouseEvent<HTMLDivElement>) => void | Promise<void>
};

const SharesCard = ({ image, title, day, id, slug }: Props) => {
  const router = useRouter();
  let imageUrl = '/'; // Agar rasm yo‘q bo‘lsa, fallback rasm
  const t = useTranslations('Components.stock-card');
  try {
    if (image && config.publicApiUrl) {
      imageUrl = `${config.publicApiUrl}${image}`;
    }
  } catch (error) {
    console.error('Rasm yuklashda xatolik:', error);
  }

  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength
      ? text.substring(0, maxLength) + '...'
      : text;
  };

  return (
    <div
      className={styles.sharesCardWrapper}
      onClick={() => router.push(`/promotions/${decodeBase64Id(id)}-${slug}`)}
    >
      <div className={styles.topWrapper}>
        <div className={styles.imgWrapper}>
          <Image
            src={imageUrl}
            alt={'shares-image'}
            className={styles.img}
            width={534}
            height={300}
          />
        </div>
        <div className={styles.titleWrapper}>
          <Link className={styles.title} href={'#'}>
            {truncateText(title, 45)}
          </Link>
        </div>
      </div>
      <div className={styles.dateWrapper}>
        <p>{t('still-time-left')}:</p>
        <div className={styles.day}>
          {day} {t('days')}
        </div>
      </div>
    </div>
  );
};

export default SharesCard;
